import { Link } from "react-router-dom";
import { ChevronDown } from "lucide-react";
import { imgSrc } from "@/lib/api";
import {
    DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
    DropdownMenuItem, DropdownMenuSeparator, DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";

export function UserMenu({ user, logout, navigate, t, textColor, linkHover }) {
    if (!user) {
        return <Link to="/login" data-testid="nav-signin" className={`font-sans text-sm ${textColor} ${linkHover}`}>{t("nav.signIn")}</Link>;
    }
    return (
        <DropdownMenu>
            <DropdownMenuTrigger data-testid="user-menu-trigger" className={`flex items-center gap-2 text-sm ${textColor} ${linkHover}`}>
                <span className="w-8 h-8 rounded-full bg-forest text-bone flex items-center justify-center text-xs font-semibold overflow-hidden">
                    {user.picture ? <img src={imgSrc(user.picture)} alt="" className="w-full h-full object-cover" /> : (user.name?.[0]?.toUpperCase() || "G")}
                </span>
                <span className="hidden xl:inline">{user.name?.split(" ")[0]}</span>
                <ChevronDown size={14} />
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56 rounded-sm">
                <DropdownMenuLabel className="font-sans text-xs uppercase tracking-widest2 text-espresso">
                    {user.email}
                </DropdownMenuLabel>
                <DropdownMenuSeparator />
                <DropdownMenuItem data-testid="menu-my-stay" onClick={() => navigate("/dashboard")}>{t("nav.myReservations")}</DropdownMenuItem>
                <DropdownMenuItem data-testid="menu-profile" onClick={() => navigate("/profile")}>{t("nav.profile")}</DropdownMenuItem>
                {user.role === "admin" && (
                    <DropdownMenuItem data-testid="menu-admin" onClick={() => navigate("/admin")}>{t("nav.adminDashboard")}</DropdownMenuItem>
                )}
                <DropdownMenuSeparator />
                <DropdownMenuItem data-testid="menu-logout" onClick={async () => { await logout(); navigate("/"); }}>{t("nav.signOut")}</DropdownMenuItem>
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
